module.exports = __webpack_public_path__ + "15cd68e95ab31d437a8c78f5b905d090.png";